export default {
  uploading: 'Uploading',
  cancel: 'Cancel',
  editTitle: 'Edit Ad-Hoc Model',
  newTitle: 'New Ad-Hoc Model',
  save: 'Save',
  create: 'Create',
  modelCodename: 'Model Codename',
  modelName: 'Model Name',
  json: 'JSON',
  stages: 'Stages',
  settings: 'Settings',
  enableDataUploader: 'Enable Data Uploader',
  slackChannel: 'Slack Channel',
  enableAISummary: 'Enable AI Summary',
  impressionsModel: 'Impressions Model',
  useDifferentConfigForPlans: 'Use different config/PKL for plans',
  modelReportPkl: 'Model Report PKL',
  modelPkl: 'Model PKL',
  downloadModelReportPkl: 'Download current Model Report PKL file',
  downloadPkl: 'Download current PKL file',
  noPklAvailable: 'No PKL file available for this model',
  choosePklFile: 'Choose PKL file to upload',
  pklRequired: 'PKL file is required',
  plansConfiguration: 'Plans Configuration',
  plansJson: 'Plans JSON',
  plansJsonRequired: 'Plans JSON is required when using different config/PKL for plans',
  downloadPlansPkl: 'Download current Plans PKL file',
  plansPkl: 'Plans PKL',
  noPlansPklAvailable: 'No Plans PKL file available for this model',
  choosePlansPklFile: 'Choose Plans PKL file to upload',
  plansPklRequired: 'Plans PKL file is required when using different config/PKL for plans',
  codenameRequired: 'Codename is required',
  codenameInvalid: 'Codename can only contain alphanumeric characters, "-", or "_"',
  codenameExists: 'Codename already exists',
  nameRequired: 'Name is required',
  invalidJson: 'Invalid JSON',
  invalidPlansJson: 'Invalid Plans JSON',
  version: 'Version',
  optimizerGpu: 'Plan Optimizer GPU',
  optimizerGpuHint: 'GPU of the servers that run this model\'s Plan Optimizer plans. Plan Calculator, Budget Simulator and model reports always use one T4.',
  gpuT4: '1× T4 (default)',
  gpuA100: '1× A100 40GB',
  uploadFailedCreate: 'The file {file} could not be uploaded, so the model was not created. Check your connection and try again. ({error})',
  uploadFailedEdit: 'The file {file} could not be uploaded, so the changes were not saved. Check your connection and try again. ({error})'
}
